







import { createComponent, computed } from "@vue/composition-api";
import { useGetters, runesToString } from "@/helpers";

export default createComponent({
  setup(props, context) {
    const { getRuneByName } = useGetters("getRuneByName");

    const errorCode = computed(() => {
      const neveRune = getRuneByName.value("neve");
      const atzRune = getRuneByName.value("atz");
      if (neveRune && atzRune) {
        return runesToString([neveRune, atzRune, neveRune]);
      } else {
        return "404";
      }
    });

    return {
      errorCode,
    };
  },
});
